import { AddOutlined, KeyOutlined } from "@mui/icons-material";
import { Box, Container, Grid, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import {
    ListDetailViewSectionContent,
    ListDetailViewSectionHeader,
    ListDetailViewSectionLayout,
} from "../../components/ListDetailView";
import { PeriodSelector } from "../../components/Period";
import { useUserInfo } from "../../utils/security";
import { useTimesheetState } from "../timesheets/TimesheetOverview";

export const EmployeesOverview = ({
    employeeId,
    loading,
    onAddTransaction,
    onShowRecurringDialog,
    ...others
}) => {
    const { userInfo, hasRight } = useUserInfo();
    const [tab, setTab] = useState("timesheets");
    const { data, filter, setFilter } = useTimesheetState(employeeId);

    return (
        <ListDetailViewSectionLayout loading={loading}>
            <ListDetailViewSectionHeader
                title="Lidé"
                titleNode={
                    <>
                        <Tabs value={tab} onChange={(_, tab) => setTab(tab)}>
                            {userInfo.timesheetsSupport && hasRight("TIMESHEETS_VIEW") && (
                                <Tab label="Výkazy" value="timesheets" />
                            )}
                        </Tabs>
                        <PeriodSelector
                            value={filter.period || {}}
                            onChange={(period) => setFilter({ ...filter, period })}
                            disabled={loading}
                            withDetail
                        />
                    </>
                }
                role="overview"
                loading={loading}
                actions={[
                    {
                        title: "Přidat",
                        icon: <AddOutlined />,
                        onClick: onShowRecurringDialog,
                    },
                ]}
            />
            <ListDetailViewSectionContent>
                {/*<PeriodField />*/}
                <Container maxWidth="xl">
                    <Box sx={{ py: 4 }}>TODO</Box>
                </Container>
            </ListDetailViewSectionContent>
        </ListDetailViewSectionLayout>
    );
};
